import React from 'react'

/**
 * AppContext
 * Use this to store app specific config values that are
 * shared across many components.
 */
export const AppContext = React.createContext({
  domain: null,
  environment: null,
  site: null,
})
